<template>
  <v-card class="mx-auto overflow-visible " width="1000px" style="margin-top: 0px; margin-bottom: 0px;" outlined>
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible">
        <v-container>
          <v-row class="align-center">
            <v-col cols="10">
              <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon aria-label="Close" @click="closeMenu">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" v-for="(item, index) in configCardFilterForm" :key="index">
              <common-range-picker
                  v-if="item.type === 'common-range-picker'"
                  :clearable="item.clearable"
                  :aLight="item.aLight"
                  :label="item.label"
                  v-model="filterForm[item.vModelKey]"
              ></common-range-picker>
              <v-autocomplete
                  v-if="item.type === 'v-autocomplete'"
                  v-model="filterForm[item.vModelKey]"
                  :items="mapListOptionsFilterForm[item.itemsKey]"
                  :item-text="item.itemText"
                  :item-value="item.itemValue"
                  :placeholder="item.placeholder"
                  :clearable="item.clearable"
                  :multiple="item.multiple"
                  :hide-details="item.hideDetails"
              />
              <v-text-field
                  v-if="item.type === 'v-text-field'"
                  :clearable="item.clearable"
                  :placeholder="item.placeholder"
                  :label="item.label"
                  v-model="filterForm[item.vModelKey]"
                  :hide-details="item.hideDetails"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <div class="text-center mb-4">
          <v-btn class="grey lighten-1 mx-2" style="color: black" @click="closeMenu">
            Hủy
          </v-btn>
          <v-btn class="primary mx-2" @click="searchContact">
            <v-icon>mdi-magnify</v-icon>Tìm kiếm nâng cao
          </v-btn>
          <v-btn class="primary mx-2" @click="exportExcel" >
            <v-icon>mdi-download</v-icon>Download
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
import moment from 'moment'
import RepositoryFactory from '@/repositories/RepositoryFactory';
import { subjectTest } from '@/helpers/constants';
const OrderRepository = RepositoryFactory.get('order');
import {SUBJECTS_SORT_CLASS} from '@/helpers/constants'
import TokenService from '@/helpers/token'
import { configCardFilterForm } from '../config'
import {downloadFile} from "@/helpers/utils";
import Repository from "@/repositories/Repository";
const orderApiUrl = Repository.defaults.orderApi;
export default {
  name: 'StatusFilterForm',
  props: {
    distributionStatus: {
      type: Array,
      default: () => []
    },
    filterForm: {
      default: () => ({})
    },
    mapListOptionsFilterForm: {
      default: () => ({})
    },
    studyHours: {
      default: () => []
    },
    statusId: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentPicker: null,
      showPopupDate: false,
      usersTemp: [],
      userPostion: TokenService.getPosition(),
      showContactedErrors: false,
      minDateContacted: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      typeSearch: [
        {
          label: 'Bằng',
          value: 'eq'
        }, {
          label: 'Lớn hơn',
          value: 'gt'
        }, {
          label: 'Nhỏ hơn',
          value: 'lt'
        }
      ],
      socialValue:null,
      openTree: false,
      search: '',
      open: [1],
      allOpened: false,
      lastOpen: [],
      subjectTest,
      showCumulatedErrors: false,
      isMonthPicker: false,
      districtList: [],
      schoolList: [],
      SUBJECTS_SORT_CLASS,
      configCardFilterForm,
    }
  },
  methods: {
    showDate(index) {
      this.currentPicker = index;
    },
    closeMenu() {
      this.filterForm.closeMenu = false
    },
    searchContact() {
      if (this.filterForm.isContacted && (!_.isArray(this.filterForm.contactedAt) || !this.filterForm.contactedAt.length)) {
        this.showContactedErrors = true
      } else if ((this.filterForm.monthPicker || this.filterForm.inputPointCumulated ) && (!this.filterForm.monthPicker ||  !this.filterForm.compare || !this.filterForm.inputPointCumulated)) {
        this.showCumulatedErrors = true;
      }
      else {
        this.showContactedErrors = false;
        this.showCumulatedErrors = false;
        Bus.$emit('contact-list-filter', this.filterForm);
      }
    },
    checkEmptyFilterForm() {
      switch(true) {
        case this.filterForm.timeRange[0]?.length > 0:
          return true
        default:
          return false
      }
    },
    async exportExcel() {
      if (!this.checkEmptyFilterForm()) {
        this.$swal({
          type: 'error',
          title: 'Thông báo !',
          text: 'Thời gian không được để trống',
        })
        return;
      }
      const params = {
        keyword: this.filterForm.keyword?.trim(),
      };
      if(this.filterForm.paymentProvider){
        params.paymentName = this.filterForm.paymentProvider
      }
      if(this.filterForm.paymentTypeId){
        params.paymentType = this.filterForm.paymentTypeId
      }
      if(this.filterForm.timeRange && this.filterForm.timeRange.length > 1){
        params.startDate = `${moment(this.filterForm.timeRange[0]).format('DD/MM/YYYY')}`
        params.endDate = `${moment(this.filterForm.timeRange[1]).format('DD/MM/YYYY')}`
      }
      OrderRepository.exportExcelPaymentHub(params);
      this.$swal({
        title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
      })
    },
    removeNodeSelected() {
      this.filterForm.userIds = []
    },
    removeOrderSelected() {
      this.filterForm.orderCreatedBy = []
    },
  },
};
</script>
<style scoped>

  /deep/.hide-date .daterangepicker.dropdown-menu{
    display: none
  }
  /deep/.show-date .daterangepicker.dropdown-menu{
    display: block;
  }
  .tree-user-selected {
    height: 34px;
    overflow-y: auto;
    border-bottom: 1px solid #d2d2d2;
  }
  .menu-wrapper-tree-user {
    background: #FFFFFF !important;
  }
  .tree-view-wrapper {
    max-height: 350px;
    overflow-y: auto;
  }
  .icon-clear-all {
    position: absolute;
    right: 15px;
    top: 20px;
    background: white;
  }
  /deep/.v-subheader.theme--light {
    width: 100%;
    background: rgb(206, 150, 104);
  }
</style>
